import QueryString from 'query-string';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const EMAIL_ERROR_MESSAGES = {
    nl: 'Vul een geldig e-mailadres in.',
    fr: 'Veuillez indiquer une adresse e-mail valide.',
    en: 'Please provide a valid e-mail address.',
};

const getEmailErrorMessage = () => {
    const lang = (document.documentElement.lang || 'en').slice(0, 2);

    return EMAIL_ERROR_MESSAGES[lang] || EMAIL_ERROR_MESSAGES.en;
};

const validateContactEmail = (form) => {
    const emailInput = form.querySelector('#edit-email');

    if (!emailInput) {
        return;
    }

    const error = document.createElement('div');
    error.id = 'edit-email-error';
    error.className = 'description inline-message inline-message--error';
    error.setAttribute('role', 'alert');
    error.hidden = true;
    emailInput.insertAdjacentElement('afterend', error);
    emailInput.setAttribute('aria-describedby', error.id);

    const showError = () => {
        emailInput.classList.add('is-error');
        emailInput.setAttribute('aria-invalid', 'true');
        error.textContent = getEmailErrorMessage();
        error.hidden = false;
    };

    const clearError = () => {
        emailInput.classList.remove('is-error');
        emailInput.removeAttribute('aria-invalid');
        error.textContent = '';
        error.hidden = true;
    };

    emailInput.addEventListener('input', () => {
        if (EMAIL_PATTERN.test(emailInput.value.trim())) {
            clearError();
        }
    });

    form.addEventListener('submit', (event) => {
        const email = emailInput.value.trim();
        emailInput.value = email;

        if (EMAIL_PATTERN.test(email)) {
            clearError();
            return;
        }

        event.preventDefault();
        showError();
        emailInput.focus();
    });
};

(() => {
    const {
        reason,
        domain,
        question,
    } = QueryString.parse(window.location.search);

    const reasonInput = document.getElementById(`edit-reason-${reason}`);
    const domainInput = document.getElementById('edit-domain');
    const questionInput = document.getElementById('edit-question');

    if (reason && reasonInput) {
        reasonInput.checked = true;
    }

    if (domain && domainInput) {
        domainInput.value = domain;
    }

    if (question && questionInput) {
        questionInput.value = question;
    }

    const form = document.getElementById('wmcustom-contact');

    if (form) {
        validateContactEmail(form);
    }
})();
